// Constantes compartidas del sistema de demos (usadas por DemoOutcomeModal,
// MisAgendas y la sección Demo de LeadEditModal).
export const OUTCOMES = [
  { k: "realizada", label: "Realizada" },
  { k: "vendida", label: "Vendida" },
  { k: "no_show", label: "No-show" },
  { k: "perdida", label: "Perdida" },
  { k: "reagendada", label: "Reagendar" },
  { k: "no_corresponde", label: "No corresponde" },
];

export const STATUS_COLOR = {
  agendada: "bg-blue-50 text-blue-700",
  realizada: "bg-green-50 text-green-700",
  vendida: "bg-emerald-100 text-emerald-800",
  no_show: "bg-red-50 text-red-700",
  perdida: "bg-gray-100 text-gray-600",
  reagendada: "bg-amber-50 text-amber-700",
  cancelada: "bg-red-100 text-red-800",
  no_corresponde: "bg-slate-100 text-slate-600",
};

export function isPendingFollowUp(demo, nowMs) {
  if (!demo || demo.status !== "agendada" || !demo.scheduled_at) return false;
  return new Date(demo.scheduled_at).getTime() < nowMs;
}

// Espejo ESM de releasableEventId de aws_lambdas/v_manageDemos/demoCore.js: decide si una
// demo tiene hueco de calendario que liberar (landing/flow/manual/config y aún no ocurrida).
// Los dos deben decidir IGUAL, o el aviso al usuario promete algo que el backend no hace.
export function releasableEventId(demo, nowMs) {
  if (!demo || !demo.scheduled_at) return null;
  const parts = String(demo.demo_id || "").split("#");
  if (parts.length !== 3) return null;
  const [, origin, eventId] = parts;
  if (origin !== "landing" && origin !== "flow" && origin !== "manual" && origin !== "config") return null;
  if (!eventId) return null;
  const at = Date.parse(demo.scheduled_at);
  if (!Number.isFinite(at) || at <= nowMs) return null;
  return eventId;
}

// Resultados de una llamada de CONFIGURACIÓN (llamada 2). Sin vendida/perdida/no_corresponde:
// esos son del pipeline comercial de la demo, no de la puesta en marcha.
export const CONFIG_OUTCOMES = [
  { k: "realizada", label: "Realizada" },
  { k: "no_show", label: "No-show" },
  { k: "reagendada", label: "Reagendar" },
  { k: "cancelada", label: "Cancelar" },
];
